export enum ConciliationItemTypeEnum {
  DIVERGENCE = "DIVERGENCE",
  NSU = "NSU",
}

export enum ConciliationItemEventEnum {
  CREATED = "CREATED",
  FIELD_CHANGED = "FIELD_CHANGED",
  STORE_RESPONDED = "STORE_RESPONDED",
  DELETED = "DELETED",
  CONCILIATED = "CONCILIATED",
  UNCONCILIATED = "UNCONCILIATED",
  SUBMITTED_FOR_APPROVAL = "SUBMITTED_FOR_APPROVAL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  APPROVAL_INVALIDATED = "APPROVAL_INVALIDATED",
  REVERSED = "REVERSED",
  VOUCHER_CREATED = "VOUCHER_CREATED",
  VOUCHER_CANCELLED = "VOUCHER_CANCELLED",
  VOUCHER_RELEASED = "VOUCHER_RELEASED",
  VOUCHER_AUTO_APPROVED = "VOUCHER_AUTO_APPROVED",
  VOUCHER_DECIDED = "VOUCHER_DECIDED",
}

export enum ConciliationChangeOriginEnum {
  BATCH_EDIT = "BATCH_EDIT",
  SINGLE_EDIT = "SINGLE_EDIT",
  DIVERGENCE_CONCILIATION = "DIVERGENCE_CONCILIATION",
  NSU_EDIT = "NSU_EDIT",
  MANUAL_CREATION = "MANUAL_CREATION",
  STORE_RESPONSE = "STORE_RESPONSE",
  APPROVAL_DECISION = "APPROVAL_DECISION",
  CONCILIATION_CLOSE = "CONCILIATION_CLOSE",
  REVERSAL = "REVERSAL",
  REPROCESS = "REPROCESS",
  BACKFILL = "BACKFILL",
}

export enum ConciliationActorTypeEnum {
  USER = "USER",
  SYSTEM = "SYSTEM",
}

export enum ConciliationCaseRelationEnum {
  SELF = "SELF",
  GROUP = "GROUP",
  DERIVED = "DERIVED",
  ORIGIN = "ORIGIN",
}

export enum ConciliationChangeFieldEnum {
  AMOUNT = "amount",
  JUSTIFICATION_ID = "justification_id",
  IS_LOSS = "is_loss",
  IS_PAYROLL_DISCOUNT = "is_payroll_discount",
  ADJUSTMENT_AMOUNT = "adjustment_amount",
  STATUS = "status",
  OPERATOR = "operator",
  REGISTER_CODE = "register_code",
  CONCILIATED_DIVERGENCE_ID = "conciliated_divergence_id",
}
